import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockCollapse {

	constructor() {
		this.collapses = document.querySelectorAll(".block-collapse .collapse, .block-text-collapse .collapse");
		this.build();
		GlobalVariables.resizeCallbacks.push(this);
	}

	build() {
		this.collapses.forEach(collapse => {
			const head = collapse.querySelector(".collapse-head");
			const body = collapse.querySelector(".collapse-body");
			body.dataset.height = body.clientHeight;
			body.style.height = 0;
			head.addEventListener("click", () => {
				if (collapse.classList.contains("open")) {
					collapse.classList.remove("open");
					gsap.to(body, {
						height: 0,
						duration: 0.3,
						onComplete: () => ScrollTrigger.refresh()
					});
				} else {
					collapse.classList.add("open");
					gsap.to(body, {
						height: body.dataset.height,
						duration: 0.3,
						onComplete: () => ScrollTrigger.refresh()
					});
				}
			});
		});
	}

	resize() {
		this.collapses.forEach(collapse => {
			const body = collapse.querySelector(".collapse-body");
			body.style.height = "auto";
			body.dataset.height = body.clientHeight;
			if (!collapse.classList.contains("open")) {
				body.style.height = 0;
			}
		});
	}
}
